import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../../providers/auth.service";
import { Users } from "../model/user";
import { isEmpty } from "lodash";

@Injectable({
  providedIn: "root",
})
export class ModuleGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const currentUser: Users = this.authService.getUser;
    if (this.isUserFeatureExist(currentUser.roleFeatures, route.data.module, route.data.privilege)) {
      return true;
    }
 //ISV users should be redirected to user-management/users page
    if (currentUser?.userType === 'ISV') {
      this.router.navigateByUrl('/user-management/users');
      return false;
    }

    // Blank screen struck when role features are not available for a particulat module
    // Thats why redirecting to error page - not found
    this.router.navigate(['error'])

    return false;
  }

  isUserFeatureExist(moduledata, moduleName, privilege) {
   // try{
      let features = this.authService.getPrivileges(moduleName)?.features;
      let isModuleExists = moduledata.some((item) => {
        return item.module === moduleName;
      });


    // Will this affect existing flow ? 
    if (isModuleExists && privilege) {
      if (typeof privilege == 'string') {
        return features.indexOf(privilege) > -1 ? true : false;
      } else {
        return !isEmpty(features.filter(element => privilege.includes(element)))
      }
    }
      return isModuleExists;
    // }catch{
    //   return false;
    // }
    
  }
}
